import styled from 'styled-components';
import accordion from '@components/Accordion';
import { Flex } from '@components/layout/Grid';
import { useState } from 'react';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';

const Accordion = styled(accordion)`
  width: auto;
  border-radius: 4px;
  padding: 6px 10px;
  margin: 6px;
  background-color: #dff5ff;
`;

const Icon = styled.img`
  width: 10px;
  height: 14px;
  margin-right: 8px;
`;

const Title = styled.p`
  display: flex;
  align-items: center;
  width: 100%;
  color: #1c343e;
  font-weight: 600;
  padding: 10px 0px;
  margin: 0;
  cursor: pointer;
  outline: none;
`;

const BlueText = styled.span`
  color: ${({ theme }) => theme.colors.primary['blue-1']};
  font-weight: 500;
`;

const BodyText = styled.div`
  padding: 0 0 8px;
  margin: 0;
`;

const ProgramRecommendation = ({ recommendation = '' }) => {
  const [open, setOpen] = useState(false);

  return (
    <Accordion
      head={
        <Flex alignItems="center" justifyContent="space-between" pr="6px">
          <Title>
            <Icon src="/static/icons/bulb-icon.svg" />{' '}
            <Trans id="programs_2022.progress.program_tip" />
          </Title>
          <BlueText>
            <Trans
              id={
                open
                  ? t`programs_2022.progress.program_recomendation_hide`
                  : t`programs_2022.progress.program_recomendation_show`
              }
            />
          </BlueText>
        </Flex>
      }
      body={<BodyText>{recommendation}</BodyText>}
      onOpenChange={() => setOpen(open => !open)}
    />
  );
};

export default ProgramRecommendation;
